import { setAccessTokenLS, removeAccessTokenLS } from 'src/utils/localStorageUtils';

import axios, { endpoints } from 'src/lib/axios';

import { setSession } from './utils';

// ----------------------------------------------------------------------

export type SignInParams = {
  email: string;
  password: string;
};

export type SignUpParams = {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
};

export type ConfirmSignUpParams = {
  confirmationCode: string;
};

export type ResendSignUpCodeParams = {
  username: string;
};

/** **************************************
 * Sign in
 *************************************** */
export const signInWithPassword = async ({ email, password }: SignInParams): Promise<void> => {
  try {
    const params = { email, password };

    const res = await axios.post(endpoints.auth.signIn, params);

    const { accessToken } = res.data;

    if (!accessToken) {
      throw new Error('Access token not found in response');
    }

    setSession(accessToken);
  } catch (error) {
    console.error('Error during sign in:', error);
    throw error;
  }
};

/** **************************************
 * Sign up
 *************************************** */
export const signUp = async ({
  email,
  password,
  firstName,
  lastName,
}: SignUpParams): Promise<void> => {
  const params = {
    email,
    password,
    firstName,
    lastName,
  };

  try {
    const res = await axios.post(endpoints.auth.signUp, params);

    const { accessToken } = res.data;

    if (!accessToken) {
      throw new Error('Access token not found in response');
    }

    // sessionStorage.setItem(JWT_STORAGE_KEY, accessToken);
    setAccessTokenLS(accessToken);
  } catch (error) {
    console.error('Error during sign up:', error);
    throw error;
  }
};

/** **************************************
 * Sign out
 *************************************** */
export const signOut = async (): Promise<void> => {
  try {
    // await setSession(null);
    await removeAccessTokenLS();
  } catch (error) {
    console.error('Error during sign out:', error);
    throw error;
  }
};

/** **************************************
 * Confirm sign up
 *************************************** */
export const confirmSignUp = async ({ confirmationCode }: ConfirmSignUpParams): Promise<void> => {
  try {
    //  try block code...
  } catch (error) {
    console.error('Error during confirm Sign Up:', error);
    throw error;
  }
};

/** **************************************
 * Resend code sign up
 *************************************** */
export const resendSignUpCode = async ({ username }: ResendSignUpCodeParams): Promise<void> => {
  try {
    //  try block code...
  } catch (error) {
    console.error('Error during resend code sign up:', error);
    throw error;
  }
};
